import SendNotificationModal from './SendNotificationModal';

export default SendNotificationModal;
